// extracted by mini-css-extract-plugin
export default {"label":"styles_label__AfyCS","container":"styles_container__cHgP5"};